import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reduce } from 'lodash';
import SelectField from '../Formik/SelectField';
import { fetchCars } from '../../actions/carActions';
import { getAllSettings } from '../../actions/adminActions';
import { getReservationGraph } from '../../actions/reservationGraphActions';

function CarSelect() {
  const dispatch = useDispatch();
  const cars = useSelector((state) =>
    reduce(
      state.cars,
      (filtered, car) => {
        if (car.active === true) {
          filtered.push({ value: car.carId, label: car.plateNo });
        }
        return filtered;
      },
      []
    )
  );

  useEffect(() => {
    dispatch(fetchCars());
    dispatch(getAllSettings());
    dispatch(getReservationGraph());
  }, []);

  if (cars.length > 0) {
    return <SelectField name="car" label="Vyberte si auto" options={cars} />;
  }

  return <div />;
}

export default CarSelect;
